"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockStakingAccrualERC20V5Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var MockStakingAccrualERC20V5Factory = /** @class */ (function (_super) {
    __extends(MockStakingAccrualERC20V5Factory, _super);
    function MockStakingAccrualERC20V5Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockStakingAccrualERC20V5Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockStakingAccrualERC20V5Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockStakingAccrualERC20V5Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockStakingAccrualERC20V5Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockStakingAccrualERC20V5Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return MockStakingAccrualERC20V5Factory;
}(contracts_1.ContractFactory));
exports.MockStakingAccrualERC20V5Factory = MockStakingAccrualERC20V5Factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_defiPassportContract",
                type: "address",
            },
        ],
        name: "DefiPassportContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "ExitCooldownDurationSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_cooldownEndTimestamp",
                type: "uint256",
            },
        ],
        name: "ExitCooldownStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Exited",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_streamId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "FundsWithdrawnFromSablier",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_passportScoresContract",
                type: "address",
            },
        ],
        name: "PassportScoresContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "_protocol",
                type: "string",
            },
        ],
        name: "ProofProtocolSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "SablierContractSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_newStreamId",
                type: "uint256",
            },
        ],
        name: "SablierStreamIdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "ScoreThresholdSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "Staked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "TokensRecovered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimStreamFunds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "cooldowns",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "exit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "exitCooldownDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getExchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getProofProtocol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "__name",
                type: "string",
            },
            {
                internalType: "string",
                name: "__symbol",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "__decimals",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_stakingToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_exitCooldownDuration",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "init",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "passportScoresContract",
        outputs: [
            {
                internalType: "contract ISapphirePassportScores",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "proofProtocol",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "recoverTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierContract",
        outputs: [
            {
                internalType: "contract ISablier",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sablierStreamId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "scoreThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timestamp",
                type: "uint256",
            },
        ],
        name: "setCurrentTimestamp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_duration",
                type: "uint256",
            },
        ],
        name: "setExitCooldownDuration",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_passportScoresContract",
                type: "address",
            },
        ],
        name: "setPassportScoresContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "_protocol",
                type: "bytes32",
            },
        ],
        name: "setProofProtocol",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_sablierContract",
                type: "address",
            },
        ],
        name: "setSablierContract",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_sablierStreamId",
                type: "uint256",
            },
        ],
        name: "setSablierStreamId",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "setScoreThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_proof",
                type: "tuple",
            },
        ],
        name: "stake",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "_v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "_r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "_s",
                type: "bytes32",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "bytes32",
                        name: "protocol",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_proof",
                type: "tuple",
            },
        ],
        name: "stakeWithPermit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IPermittableERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "startExitCooldown",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "token",
                type: "uint256",
            },
        ],
        name: "toStakedToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "stTokenAmount",
                type: "uint256",
            },
        ],
        name: "toStakingToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
